import { FlagType } from '@/types';

export type AttackSurfaceFlagKey =
  | 'external'
  | 'internal'
  | 'cloud'
  | 'users'
  | 'device'
  | 'code'
  | 'llm';

export type AttackSurfaceFlagSelection = Partial<
  Record<AttackSurfaceFlagKey, boolean>
>;

export const ATTACK_SURFACE_FLAG_MAP: Record<AttackSurfaceFlagKey, FlagType> = {
  external: FlagType.ENABLE_EXTERNAL,
  internal: FlagType.ENABLE_BREACH_AND_ATTACK,
  cloud: FlagType.ENABLE_CLOUD,
  users: FlagType.ENABLE_USERS,
  device: FlagType.ENABLE_DEVICE,
  code: FlagType.ENABLE_CODE,
  llm: FlagType.ENABLE_LLM,
};

export function getAttackSurfaceFlagUpdates(
  attackSurface: AttackSurfaceFlagSelection
): { flagsToAdd: string[]; flagsToDelete: string[] } {
  const flagsToAdd: string[] = [];
  const flagsToDelete: string[] = [];

  Object.entries(ATTACK_SURFACE_FLAG_MAP).forEach(([surface, flag]) => {
    if (attackSurface[surface as AttackSurfaceFlagKey]) {
      flagsToAdd.push(flag);
    } else {
      flagsToDelete.push(flag);
    }
  });

  return { flagsToAdd, flagsToDelete };
}
